import React from 'react';
import resume from '../assests/resume.pdf'; // Import your PDF resume
import profileImage from '../assests/profile_pic.jpeg'; // Import your profile image (if applicable)

const ContactPage = () => {
  return (
    <div className="w-full min-h-screen text-blue-light bg-gray-100 pt-[120px]">
      <div className="max-w-[900px] mx-auto p-8 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <h1 className="text-4xl font-bold inline border-b-4 border-blue-dark text-blue-dark">
            Contact Me
          </h1>
          <p className="py-6 text-gray-700">
            Feel free to reach out to me via email, GitHub, or LinkedIn. You can also download my resume.
          </p>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark border-b-2">Contact Information</h2>
          <p className="py-4 text-gray-600">
            I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision. 
            Here’s how you can reach me:
          </p>
          
          <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-8">
            {/* Profile Image */}
            <div className="w-full h-52 md:w-1/4 text-gray-600 ">
                <div
                style={{ backgroundImage: `url(${profileImage})` }}
                className="w-full h-full bg-cover bg-center rounded-full"
                />
            </div>

            {/* Contact Details */}
            <div className="w-full md:w-6/12 text-gray-600 shadow-lg p-4">
              <p className="text-lg">
                <strong>Email:</strong> <a href="mailto:pinsonanthony@gmail.com" className="text-blue-dark">pinsonanthony@gmail.com</a>
              </p>
              <p className="text-lg mt-4">
                <strong>GitHub:</strong> <a href="https://github.com/AKP-ANT" target="_blank" rel="noopener noreferrer" className="text-blue-dark">github.com/AKP-ANT</a>
              </p>
              <p className="text-lg mt-4">
                <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/anthony-pinson" target="_blank" rel="noopener noreferrer" className="text-blue-dark">linkedin.com/in/anthony-pinson</a>
              </p>
            </div>
          </div>
        </div>
        
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-dark">My Resume</h2>
          {/* <p className="py-4 text-gray-600">
            You can download my resume or view it in a new tab by clicking the link below.
          </p> */}
          
          <div className="flex justify-center">
            <a href={resume} target="_blank" rel="noopener noreferrer">
                <button className="bg-blue-dark text-base font-semibold py-2 px-4 rounded shadow hover:bg-blue-light transition duration-200">
                    View Resume in New Tab
                </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
